Component({
    externalClasses: ["ex-class"],
    options: {
        styleIsolation: "apply-shared",
        pureDataPattern: /^_/
    },
    /**
     * Component properties
     */
    properties: {
        values: {
            type: Array,
            value: []
        },
        current: {
            type: Number,
            value: 0
        },
        layout: {
            type: String,
            value: "center"
        },
        theme: {
            type: String,
            value: "ios12"
        },
        exStyle: {
            type: String,
            value: ""
        }
    },

    /**
     * Component initial data
     */
    data: {
        _scrollLeft: 0,
        offsetLeft: 0,
        lineWidth: 100
    },

    /**
     * Component methods
     */
    methods: {
        onScroll: function onScroll(e) {
            // console.debug(e.detail);
            let { scrollLeft, scrollWidth, deltaX } = e.detail;
            this.setData({ _scrollLeft: scrollLeft })
        },
        onTap: function onTap(e) {
            let _this = this;
            let index = parseInt(e.target.dataset.index);
            if (this.properties.current !== index) {
                //重新计算滑块的位置
                setTimeout(function () {
                    let { _scrollLeft, values } = _this.data;
                    // 监听当前选择的item变化,重新计算线的宽和左边的距离
                    let query = _this.createSelectorQuery();
                    query.select('#sc-' + index).boundingClientRect();
                    query.exec(function (res) {
                        _this.setData({ current: index, offsetLeft: res[0].left + _scrollLeft, lineWidth: res[0].width });
                        _this.triggerEvent("click", { index: index, value: values[index] });
                    });
                }, 200);
            }
        }
    },
    lifetimes: {
        ready: function ready() {
            let _this = this;
            let _properties = this.properties,
                values = _properties.values,
                current = _properties.current;

            let lineWidth = 0;

            if (values && values.length > 0) {
                if (values[current]) {
                    lineWidth = 0;
                    setTimeout(function () {
                        // 延时获取线的宽度和左边距离
                        let query = _this.createSelectorQuery();
                        query.select('#sc-' + current).boundingClientRect();
                        query.exec(function (res) {
                            _this.setData({ offsetLeft: res[0].left, lineWidth: res[0].width });
                        });
                    }, 500);
                }
            }
        }
    }
});